import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import ShippingTooltip from './CartShippingTooltip';

import styles from './styles/CartNoShipping.scss';

const CartNoShipping = props => {
    const { item } = props;

    return (
        <div>
            <span className={styles.noShippingPrice} data-tn="item-to-be-quoted">
                <FormattedMessage id="CartNoShipping.quoted" defaultMessage="to be quoted" />
            </span>
            <ShippingTooltip item={item} />
        </div>
    );
};

CartNoShipping.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(CartNoShipping, {
    item: graphql`
        fragment CartNoShipping_item on Item {
            ...CartShippingTooltip_item
        }
    `,
});
